import PropTypes from "prop-types";
import React from "react";
import { Field, reduxForm } from "redux-form";
import TextField from "@material-ui/core/TextField";
import { translator } from "../utils/i18n";
import { Trans } from "@lingui/macro";
import { Button } from "@material-ui/core";
import ForgotPassword from "./ForgotPassword";

const validate = values => {
  const errors = {};
  const requiredFields = ["email", "password"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = "Invalid email address";
  }
  return errors;
};

const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const renderTextFieldEmail = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    type="email"
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const Connexion = props => {
  const { handleSubmit, pristine, submitting, message } = props;

  return (
    <form onSubmit={handleSubmit} className="custom-form connexion-form">
      {message && (
        <div className="alert" dangerouslySetInnerHTML={{ __html: message }} />
      )}
      <div className="line-form">
        <Field
          name="email"
          component={renderTextFieldEmail}
          label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
          variant="outlined"
        />
        <Field
          name="password"
          type="password"
          component={renderTextField}
          label={translator()._("CP_PASSWORD")}
          variant="outlined"
        />
      </div>

      <div>
        <ForgotPassword />
      </div>
      <div className="bottom">
        <Button
          type="submit"
          color="primary"
          disabled={pristine || submitting}
          variant="contained"
        >
          <Trans id="CP_SEND" />
        </Button>
      </div>
    </form>
  );
};

Connexion.propTypes = {
  handleSubmit: PropTypes.func,
  message: PropTypes.string,
  pristine: PropTypes.any,
  submitting: PropTypes.any
};

export default reduxForm({
  form: "ConnexionForm", // a unique identifier for this form
  validate
})(Connexion);
